import React from "react";
import GoogleMapReact from "google-map-react";
import { ContactProps } from "./interfaces/Contact";
import Text from "../Common/Text";
import Container from "../Common/Container";
import { FiMapPin } from "react-icons/fi";

const Contact = ({
  data,
  onChange,
}: {
  data: ContactProps;
  onChange: (value: any, id: string) => void;
}) => {
  return (
    <Container className="my-10" id="Contact">
      <div
        className="bg-white rounded-[--border-radius] "
        id="ContactContainer1"
      >
        <div className="mx-auto max-w-7xl px-6 py-4 lg:px-8">
          <div
            id="ContactContainerRow"
            className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-12 flex-col-reverse"
          >
            <div
              id="ContactContainerCol1"
              className={`lg:pt-4 col-span-5 ${
                data?.alling === "RIGHT" ? "order-2" : "order-1"
              }`}
            >
              <div id="ContactContainerText" className="lg:max-w-lg">
                <Text
                  editor={!!onChange}
                  id="Contact"
                  onChange={(val: any) => onChange?.(val, "description")}
                >
                  {data?.description}
                </Text>
              </div>
            </div>
            <div
              id="ContactContainerCol2"
              className={`${
                data?.alling === "RIGHT" ? "order-1" : "order-2"
              } col-span-7`}
              style={{ minHeight: "400px" }}
            >
              <div
                id="ContactMap"
                className="google_map__container"
                style={{ height: "100%", width: "100%" }}
              >
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: "AIzaSyBs80qOcrLbWnrA4MudvNw9gxz_-P3bais",
                  }}
                  draggable={false}
                  defaultCenter={{
                    lat: parseFloat(data?.map?.latitude || "0"),
                    lng: parseFloat(data?.map?.longitude || "0"),
                  }}
                  defaultZoom={15}
                >
                  <PinLocation
                    lat={parseFloat(data?.map?.latitude || "0")}
                    lng={parseFloat(data?.map?.longitude || "0")}
                    text={data?.address}
                  />
                </GoogleMapReact>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

const PinLocation = ({ lat, lng, text }: any) => {
  return (
    <FiMapPin
      className="text-lg PIN_LOCATION text-[primary800]"
      style={{
        width: "25px",
        height: "25px",
        position: "relative",
        top: "-25px",
        left: "-13px",
      }}
    >
      {text}
    </FiMapPin>
  );
};

export default Contact;
